import { domain, i18n } from 'arm-common';
import * as layouts from 'arm-core-layouts';
import { InputFile } from 'arm-file-uploader';
import * as agui from 'arm-gui/dist/controls';
import * as React from 'react';
import { connect } from 'react-redux';
import Rest from '../../webapi/Rest';
import DocumentiActions from '../documenti/DocumentiActions';
import { FileConfBox } from '../documenti/FileConfBox';

class DocumentTab extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Upload.jsx] ";
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            validation: new Map(),
            showConfirmSalvaDoc: false
        };
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount')
    }

    validateForm() {
        let validation = new Map();
        let required = ['pdfForm', 'excel', 'denominazioneRin'];
        for (let i = 0; i < required.length; i++) {
            if (this.props.utilities[required[i]] === undefined || this.props.utilities[required[i]] === '' || this.props.utilities[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRINT.SHARED.VALORE_OBBLIGATORIO', 'Campo obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    onFileUpload = (file, name) => {
        if (this.state.validation.has("content")) {
            this.state.validation.delete("content");
            this.setState({ validation: this.state.validation })
        }
        const f = {
            fileId: name,
            fileName: file.name,
            descrizione: "",
            // numTotFirmatari: "1",
            docId: null,
        };
        this.props.handleChangeUtilities("content", f);
    };

    templateUpload = (file, name, tipo) => {
        if (this.state.validation.has("template")) {
            this.state.validation.delete("template");
            this.setState({ validation: this.state.validation })
        }
        const f = {
            fileId: name,
            fileName: file.name,
            descrizione: "",
            // numTotFirmatari: "1",
            docId: null,
        };
        this.props.handleChangeUtilities(tipo, f);
    };

    handleChange(id, value, tipo) {
        if (this.state.validation.has(id)) {
            this.state.validation.delete(id);
            this.setState({ validation: this.state.validation })
        }
        this.props.handleChangeUtilities(id, value, tipo);
    }

    generaTemplate() {
        if (this.validateForm()) {
            this.props.generaTemplate(this.props.utilities?.pdfForm?.fileId, this.props.utilities?.excel?.fileId, this.props.utilities?.denominazioneRin)
        }
    }


    render() {
        const { nuovoDoc } = this.props;
        const baseUrl = Rest.restBaseurl;

        return (
            <>

                <div className='row'>
                    <div className='col-6'>
                        <div className={this.state.validation.get("pdfForm") === "" || this.state.validation.get("pdfForm") === null || this.state.validation.get("pdfForm") === undefined ? "mb-2 input-file-row input-template w-100 mt-4" : "mb-2 input-file-row input-template-error w-100 mt-4"} >

                            <>
                                <span className="lab-input-file">{i18n("ARM_CORE_PRINT.SHARED.UPLOAD_FORM_PDF", "Seleziona qui il file PDF")} </span>
                                <InputFile
                                    ref={(r) => this.inputFile = r}
                                    label={i18n("ARM_CORE_PRINT.SHARED.UPLOAD_FORM_PDF", 'Upload Form PDF')}
                                    compact={true}
                                    clearOnUpload={true}
                                    onFileUpload={(f, n) => this.templateUpload(f, n, "pdfForm")}
                                    uploadURL={baseUrl}
                                    id='pdfForm'
                                    name='pdfForm'
                                    className='pdfForm'
                                />
                            </>

                            <div className="files mt-2">
                                {
                                    this.props.utilities?.pdfForm?.docId || this.props.utilities?.pdfForm?.fileId ?
                                        <FileConfBox scaricaDocument={this.props.scaricaDocument}
                                            label={i18n("ARM_CORE_PRINT.SHARED.PDF", 'PDF')}
                                            file={this.props.utilities.pdfForm}
                                            isInEditMode={true}
                                            fileIdx={this.props.utilities.pdfForm.docId}
                                            removeFile={() => this.props.removeFile(null, 'pdfForm')}
                                            change={this.change} />
                                        : null
                                }

                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className={this.state.validation.get("excel") === "" || this.state.validation.get("excel") === null || this.state.validation.get("excel") === undefined ? "mb-2 input-file-row input-template w-100 mt-4" : "mb-2 input-file-row input-template-error w-100 mt-4"} >

                            <>
                                <span className="lab-input-file">{i18n("ARM_CORE_PRINT.SHARED.UPLOAD_FORM_PDF", "Seleziona qui il file Excel")} </span>
                                <InputFile
                                    ref={(r) => this.inputFile = r}
                                    label={i18n("ARM_CORE_PRINT.SHARED.UPLOAD_CAMPI_EXCEL", 'Upload campi Excel')}
                                    compact={true}
                                    clearOnUpload={true}
                                    onFileUpload={(f, n) => this.templateUpload(f, n, "excel")}
                                    uploadURL={baseUrl}
                                    id='excel'
                                    name='excel'
                                    className='template'
                                />
                            </>

                            <div className="files mt-2">
                                {
                                    this.props.utilities?.excel?.docId || this.props.utilities?.excel?.fileId ?
                                        <FileConfBox scaricaDocument={this.props.scaricaDocument}
                                            label={i18n("ARM_CORE_PRINT.SHARED.EXCEL", 'Excel')}
                                            file={this.props.utilities.excel}
                                            fileIdx={this.props.utilities.excel.docId}
                                            isInEditMode={true}
                                            removeFile={() => this.props.removeFile(null, 'excel')}
                                            change={this.change} />
                                        : null
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-2 mb-2 alignGeneraBtn'>
                    <div className='col-6'>
                        <agui.CoolTextInput
                            id="denominazioneRin"
                            value={this.props.utilities?.denominazioneRin}
                            required={true}
                            hasError={this.state.validation.get("denominazioneRin")}
                            label={i18n('ARM_CORE_PRINT.DS.DENOMINAZIONE', 'Denominazione')}
                            onChange={(value) => this.handleChange('denominazioneRin', value)}
                        />
                    </div>
                    <div className='col-6 mt-4'>
                        <agui.aButton bs='primary' icon="fas fa-file-pdf"
                            // onClick={() => this.props.generaTemplate(this.props.utilities?.pdfForm?.fileId, this.props.utilities?.excel?.fileId)}
                            onClick={() => this.generaTemplate()}
                        >
                            {i18n('ARM_CORE_PRINT.UTILITIES.GENERA_TEMPLATE', 'Genera TEMPLATE')}
                        </agui.aButton>
                    </div>
                </div>
                {/* <agui.aButton bs='primary' icon="fas fa-file-pdf"
                    // onClick={() => this.props.generaTemplate(this.props.utilities?.pdfForm?.fileId, this.props.utilities?.excel?.fileId)}
                    onClick={() => this.generaTemplate()}
                >
                    {i18n('ARM_CORE_PRINT.UTILITIES.GENERA_TEMPLATE', 'Genera TEMPLATE')}
                </agui.aButton> */}

            </>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleChangeUtilities(id, value, tipo) {
            return dispatch(DocumentiActions.handleChangeUtilities(id, value, tipo));
        },
        removeFile(fileIdx, name) {
            return dispatch(DocumentiActions.removeFileUtilities(fileIdx, name));
        },
        eliminaDoc() {
            return dispatch(DocumentiActions.eliminaDoc());
        },
        setIsAlreadyExistingDoc(isAlreadyExistingDoc) {
            return dispatch(DocumentiActions.setIsAlreadyExistingDoc(isAlreadyExistingDoc));
        },
        resetDoc() {
            return dispatch(DocumentiActions.resetDoc());
        },
        scaricaDocument(id) {
            return dispatch(DocumentiActions.scaricaDocument(id));
        },
        validationDocument(key, value) {
            return dispatch(DocumentiActions.validationDocument(key, value))
        },
        deleteErrore(id) {
            return dispatch(DocumentiActions.deleteErrore(id))
        },
        generaTemplate(idFilePdf, idFileExcel, denominazioneRin) {
            return dispatch(DocumentiActions.generaTemplate(idFilePdf, idFileExcel, denominazioneRin))
        }


    }

};

function mapStateToProps(state) {
    return {
        listaDoc: state.documentiReducer.listaDoc,
        nuovoDoc: state.documentiReducer.nuovoDoc,
        tabSelected: state.documentiReducer.tabSelected,
        listaDataSource: state.documentiReducer.listaDataSource,
        isAlreadyExistingDoc: state.documentiReducer.isAlreadyExistingDoc,
        isInEditMode: state.documentiReducer.isInEditMode,
        parametersMap: state.documentiReducer.parametersMap,
        validationDoc: state.documentiReducer.validationDoc,
        utilities: state.documentiReducer.utilities
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentTab);
